$(document).ready(function() {

  videoPlayerInicialization();
 $(".Scrolling__Banner").marquee({ speed: 32, gap: 10, delayBeforeStart: 0, direction: "left", duplicated: !0, startVisible: 1 });
});





function videoPlayerInicialization(){
  if($('.wrapper_click--video').length > 0){
    $( ".wrapper_click--video" ).each(function( index ) {



      var options = JSON.parse($('.video-js', this).attr('data-section-settings'));
      var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false;
      const isDesktopScreenSize = new Responsive().matchesBreakpoint("lap-and-up");

      let img_plh = "";
      let aspect_ratio = "";
      let src = "";
      let controls = "";

      if(isMobile || !isDesktopScreenSize) {
        if(options['control_var']){src = options["videom"];}else{src = options["videom"]["sources"][1]['url'];}
        img_plh = options['plh_mob'];

      } else {
        if(options['control_var']){src = options["videod"];}else{src = options["videod"]["sources"][1]['url'];}
        img_plh = options['plh_desk'];
        
      }

      // The box shape follows the window width only, like the server-rendered poster's
      // aspect-ratio (sections/home_image-text.liquid, min-width 1025px), so a mobile
      // device in a wide landscape window doesn't get a box that changes shape on load.
      aspect_ratio = isDesktopScreenSize ? (options['aspect_desk'] || "16:9") : (options['aspect_mob'] || "9:16");

var shp = options['plh'];
var heroPoster = this.querySelector('.hero-poster');

if (shp){  var payload =
        {
          aspectRatio: aspect_ratio,
          autoplay: heroPoster ? false : options['autoplay'],
          muted: options['muted'],
          loop: options['loop'],
          controls: options['controls'],
          // With the server-rendered poster in place, Video.js must not add its own
          // (a black-backed div plus the native poster attribute): they paint above
          // the picture at some widths and flash while their image loads.
          poster: heroPoster ? '' : img_plh,
          preload: heroPoster ? "none" : "auto",
          playsinline: true,
          responsive: true,

          disablePictureInPicture: true,
          controlBar: {
            playToggle: true,
            captionsButton: false,
            chaptersButton: false,
            subtitlesButton: false,
            remainingTimeDisplay: false,
            pictureInPictureToggle: false,
            volumeControl: false,
            progressControl: {
              seekBar: false
            },
            fullscreenToggle: false,
            playbackRateMenuButton: false,
          },
          sources: [{
            type: "video/mp4",
            src: src
          }]

        }}
        else{
          var payload =
                {
                  aspectRatio: aspect_ratio,
                  autoplay: options['autoplay'],
                  muted: options['muted'],
                  loop: options['loop'],
                  controls: options['controls'],
                  preload: "metadata",
                  playsinline: true,
                  responsive: true,

                  disablePictureInPicture: true,
                  controlBar: {
                    playToggle: true,
                    captionsButton: false,
                    chaptersButton: false,
                    subtitlesButton: false,
                    remainingTimeDisplay: false,
                    pictureInPictureToggle: false,
                    volumeControl: false,
                    progressControl: {
                      seekBar: false
                    },
                    fullscreenToggle: false,
                    playbackRateMenuButton: false,
                  },
                  sources: [{
                    type: "video/mp4",
                    src: src
                  }]

                }
        }

      var videoplayerID = 'my-player-'+options['id'];

      const myPlayer = videojs(videoplayerID, payload);
      hideHeroPosterOnFirstFrame(myPlayer, this);
      if(heroPoster){ startClipAfterPoster(myPlayer, heroPoster, options['autoplay']); }

      if( options['viewport']){
        waitforviewport(options['pause']);
      }$(this).closest('.ImageHero--teaser').show(); });
    toggleVideo();

  }
}

// The server-rendered .hero-poster covers the player until the video has
// presented a frame, so the hand-off shows neither black nor two posters.
// If autoplay is blocked the poster simply stays until the shopper taps play.
function hideHeroPosterOnFirstFrame(player, wrapper){
  var poster = wrapper.querySelector('.hero-poster');
  if(!poster){ return; }
  var hide = function(){ poster.classList.add('hero-poster--hidden'); };
  player.one('playing', function(){
    var video = player.el().querySelector('video');
    if(video && video.requestVideoFrameCallback){ video.requestVideoFrameCallback(hide); }else{ hide(); }
  });
}

// The clip is fetched only once the poster <img> has loaded, so on a slow
// connection the two never compete for bandwidth and the poster (the page's
// largest element) appears first. On a fast connection the poster is complete
// before this runs, so the clip starts immediately.
function startClipAfterPoster(player, poster, autoplay){
  var img = poster.querySelector('img') || poster;
  var start = function(){
    player.preload('auto');
    if(autoplay){
      var p = player.play();
      if(p && p.catch){ p.catch(function(){}); }
    }
  };
  if(img.complete){ start(); }else{
    img.addEventListener('load', start, { once: true });
    img.addEventListener('error', start, { once: true });
  }
}

function toggleVideo(){

  $('.wrapper_click--video').on('click', function(){
var sph = $(this).attr('data-plh');
    var id = $(this).attr('data-id');
    var videoplayerID = 'my-player-'+id;
    var myPlayer = videojs(videoplayerID);




if(myPlayer.paused()) { myPlayer.play();
                       if(sph == "true"){$('.vjs-poster', this).css("display", "none");}
                      }else{myPlayer.pause(); if(sph == "true"){$('.vjs-poster', this).css("display", "inline-block");} $(this).attr('data-pause',true) }

  });

  $('#banner-section .vjs-poster').each(function() {
    $(this).attr('preload', 'auto');
  });

}

// function waitforviewport(pauseifout){

//   var viewportHeight = $(window).height();
//   $(window).on('scroll', function() {

//     $('.wrapper_click--video').each((index, el) => {
//       const id = $(el).attr('data-id');
//       var customID = "my-player-"+id;

//       var myPlayer = videojs(customID);

//       var inner = $("#"+customID);

//       var innerH = inner.outerHeight();
//       innerH = innerH * 0.5;

//       var elementPosTop = inner.position().top - innerH;
//       if(elementPosTop < 0){
//          elementPosTop = inner.closest('.shopify-section').position().top - innerH;
//       }

//       var elementPosBot = elementPosTop + inner.outerHeight() - 100;
//       var scrollPos = $(window).scrollTop();
//       var elementFromTop = elementPosTop - scrollPos;
//       var manual = $(el).attr('data-pause');

//       if (elementFromTop > 0 && elementFromTop < elementPosTop + viewportHeight || elementPosBot  < scrollPos  && pauseifout) {
//         myPlayer.pause(); $('.'+customID+' .vjs-poster').css("display", "inline-block");

//       } else {

//         if (!manual){
//           myPlayer.play();
//           $('.'+customID+' .vjs-poster').css("display", "none");
//         }   }

//     })

//   });


// }

function waitforviewport(pauseifout) {
  const options = {
    root: null, // Ovo označava viewport
    rootMargin: '0px',
    threshold: 0.5 // Pokreće se kada je 50% elementa u viewportu
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      const id = $(entry.target).attr('data-id');
      const customID = "my-player-" + id;
      const myPlayer = videojs(customID);

      if (entry.isIntersecting) {
        // Element je u viewportu
        const manual = $(entry.target).attr('data-pause');
        if (!manual) {
          myPlayer.play();
          $('.' + customID + ' .vjs-poster').css("display", "none");
        }
      } else {
        // Element nije u viewportu
        if (pauseifout) {
          myPlayer.pause();
          $('.' + customID + ' .vjs-poster').css("display", "inline-block");
        }
      }
    });
  }, options);

  // Dodajemo sve elemente koje želimo da pratimo
  $('.wrapper_click--video').each((index, el) => {
    observer.observe(el);
  });
}
